import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../../../services/index.js";

const nl = (label = "") => String(label).trim().toLowerCase();

const getRoute = (label) => {
  const l = nl(label);
  if (l === "screen master") return "/admin/screens";
  if (l === "role master") return "/admin/roles";
  if (l === "user management" || l === "user master") return "/admin/users";
  if (l === "workspace mapping") return "/admin/workspace-mapping";
  if (l === "data sources" || l === "datasources") return "/admin/data";
  if (l === "authorization") return "/admin/authorization";
  if (l === "usecase master" || l === "use case master") return "/admin/usecasemaster";
  if (l === "user model group mapping" || l === "user modelgroupmapping") return "/admin/usermodelgroupmapping";
  if (l === "company onboarding" || l === "company master" || l === "companies") return "/admin/companies";
  if (l === "overview" || l === "dashboard") return "/admin";
  if (l === "workspaces" || l === "workspace") return "/admin/workspaces";
  if (l === "use cases") return "/user";
  if (l === "chatbot") return "/user/chat";
  return "";
};

export default function useAuth() {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const authenticate = async (email, password) => {
    setError("");
    setIsLoading(true);

    try {
      const data = await authService.login(email, password);
      if (data?.status) {
        const userData = data.data;
        localStorage.setItem("accessToken", data.data.accessToken);
        localStorage.setItem("refreshToken", data.data.refreshToken);
        localStorage.setItem("userId", data.data.userId);
        localStorage.setItem("groupId", data.data.groupId);
        localStorage.setItem("expiresAtUtc", data.data.expiresAtUtc);
        localStorage.setItem("user", JSON.stringify(userData));

        // Fetch menu data
        const menuData = await authService.getMenu(data.data.groupId);
        console.log("menuData:", menuData);
        if (menuData?.status) {
          localStorage.setItem("menuData", JSON.stringify(menuData.data));

          // Redirect based on defaultPage label mapped to frontend route
          const defaultLabel = menuData.data?.defaultPage?.screenname || menuData.data?.defaultPage?.label || "";
          const mappedRoute = getRoute(defaultLabel);
          if (Number(data.data.groupId) === 1) {
            window.location.href = mappedRoute || "/user";
          } else {
            window.location.href = mappedRoute || "/admin";
          }
        } else {
          console.log("Menu fetch failed, redirecting based on groupId without menu data");
          navigate("/");
        }
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError(err.message || "Login failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return { authenticate, error, isLoading };
}
